import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { Right } from '@taxi/shared';

/**
 * Routes de l'application.
 *
 * `meta.granted` porte les droits exigés — jamais un rôle. La garde installée
 * par le plugin `granted` les vérifie, et `useRouteGranted` s'en sert pour
 * filtrer les entrées de menu : une entrée inaccessible n'est pas affichée.
 *
 * Rappel : ce filtrage est ergonomique, l'API revérifie tout.
 */
const routes: RouteRecordRaw[] = [
	// --- Parcours client -----------------------------------------------------
	{
		path: '/',
		name: 'home',
		component: () => import('@/views/HomeView.vue'),
		meta: { publicPage: true },
	},
	{
		path: '/destination',
		name: 'destination',
		component: () => import('@/views/client/DestinationView.vue'),
		meta: { granted: [Right.RIDE_CREATE] },
	},
	{
		path: '/confirmation',
		name: 'booking',
		component: () => import('@/views/client/BookingView.vue'),
		meta: { granted: [Right.RIDE_CREATE] },
	},
	{
		path: '/course/:id',
		name: 'ride-tracking',
		component: () => import('@/views/client/TrackingView.vue'),
		meta: { granted: [Right.RIDE_READ_OWN] },
	},
	{
		/** Cible du QR code de la borne : accessible sans compte. */
		path: '/suivi/:claimToken',
		name: 'ride-track-public',
		component: () => import('@/views/client/TrackPublicView.vue'),
		meta: { publicPage: true },
	},
	{
		path: '/mes-courses',
		name: 'ride-history',
		component: () => import('@/views/client/HistoryView.vue'),
		meta: { granted: [Right.RIDE_READ_OWN] },
	},

	// --- Compte ---------------------------------------------------------------
	{
		path: '/connexion',
		name: 'login',
		component: () => import('@/views/account/LoginView.vue'),
		meta: { publicPage: true },
	},
	{
		path: '/inscription',
		name: 'register',
		component: () => import('@/views/account/RegisterView.vue'),
		meta: { publicPage: true },
	},
	{
		path: '/compte',
		name: 'account',
		component: () => import('@/views/account/AccountView.vue'),
		meta: { granted: [Right.ACCOUNT_READ] },
	},

	// --- Mode conduite --------------------------------------------------------
	{
		path: '/conduite',
		name: 'driver-home',
		component: () => import('@/views/driver/DriverHomeView.vue'),
		meta: { granted: [Right.DRIVER_MODE] },
	},
	{
		path: '/conduite/course/:id',
		name: 'driver-ride',
		component: () => import('@/views/driver/DriverRideView.vue'),
		meta: { granted: [Right.DRIVER_RIDE_PROGRESS] },
	},
	{
		path: '/conduite/profil',
		name: 'driver-profile',
		component: () => import('@/views/driver/DriverProfileView.vue'),
		meta: { granted: [Right.DRIVER_SELF_READ] },
	},

	// Pas de route dédiée à la borne : elle emprunte exactement les mêmes écrans.
	// Seul son comportement diffère — position fixe, retour automatique à
	// l'accueil, relais par QR code — et cela se décide au sein des vues.

	{
		path: '/:catchAll(.*)',
		redirect: { name: 'home' },
	},
];

const router = createRouter({
	history: createWebHistory(),
	routes,
	scrollBehavior: () => ({ top: 0 }),
});

export default router;
